export function getElementsToBlockOverflow() {
  const { body } = document;
  const html = document.querySelector('html');
  const app = document.querySelector('#app');

  return [
    body,
    html,
    app
  ];
}

export function isSmallScreen() {
  return window.innerWidth <= 550;
}

export function blockBodyOverflow() {
  getElementsToBlockOverflow().forEach(element => {
    if (element && !element.classList.contains('overflow-hidden-wuk')) {
      element.classList.add('overflow-hidden-wuk');
    }
  });
}

export function unlockBodyOverflow() {
  getElementsToBlockOverflow().forEach(element => {
    if (element && element.classList.contains('overflow-hidden-wuk')) {
      element.classList.remove('overflow-hidden-wuk');
    }
  });
}

export function toggleBodyOverflow(block, { justBlockIfIsSmallScreen }) {
  if (justBlockIfIsSmallScreen) {
    if (block && isSmallScreen()) blockBodyOverflow();
    else unlockBodyOverflow();
  } else if (block) blockBodyOverflow();
  else unlockBodyOverflow();
}

export default {
  toggleBodyOverflow,
  blockBodyOverflow,
  unlockBodyOverflow
};
